import { render } from "./CalendarioResumen.vue?vue&type=template&id=4ec33f2e"
import script from "./CalendarioResumen.vue?vue&type=script&lang=js"
export * from "./CalendarioResumen.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__